module.exports = __webpack_public_path__ + "static/media/fire-is-correct.7b33e841.mp3";